const ChatIcon = () => (
  <svg
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className='icon'
  >
    <path
      d='M4.43479 13.3044L2.73479 15.0044C2.50074 15.2384 2.2328 15.2908 1.93099 15.1614C1.62918 15.0321 1.47827 14.8011 1.47827 14.4685V2.95653C1.47827 2.55001 1.62302 2.202 1.91251 1.91251C2.202 1.62302 2.55001 1.47827 2.95653 1.47827H14.7826C15.1891 1.47827 15.5371 1.62302 15.8266 1.91251C16.1161 2.202 16.2609 2.55001 16.2609 2.95653V11.8261C16.2609 12.2326 16.1161 12.5806 15.8266 12.8701C15.5371 13.1596 15.1891 13.3044 14.7826 13.3044H4.43479ZM3.80653 11.8261H14.7826V2.95653H2.95653V12.6576L3.80653 11.8261Z'
      fill='white'
    />
  </svg>
);

const MailIcon = () => (
  <svg
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className='icon'
  >
    <path
      d='M2.95629 14.7826C2.54977 14.7826 2.20176 14.6379 1.91227 14.3484C1.62277 14.0589 1.47803 13.7109 1.47803 13.3044V4.4348C1.47803 4.02828 1.62277 3.68027 1.91227 3.39078C2.20176 3.10129 2.54977 2.95654 2.95629 2.95654H14.7824C15.1889 2.95654 15.5369 3.10129 15.8264 3.39078C16.1159 3.68027 16.2606 4.02828 16.2606 4.4348V13.3044C16.2606 13.7109 16.1159 14.0589 15.8264 14.3484C15.5369 14.6379 15.1889 14.7826 14.7824 14.7826H2.95629ZM14.7824 5.91306L9.25738 9.3685C9.19578 9.40546 9.13111 9.43317 9.06335 9.45165C8.9956 9.47013 8.93093 9.47937 8.86933 9.47937C8.80774 9.47937 8.74306 9.47013 8.67531 9.45165C8.60756 9.43317 8.54288 9.40546 8.48129 9.3685L2.95629 5.91306V13.3044H14.7824V5.91306ZM8.86933 8.13046L14.7824 4.4348H2.95629L8.86933 8.13046ZM2.95629 6.09785V5.00763V5.02611V5.01687V6.09785Z'
      fill='#B400FF'
    />
  </svg>
);

const ArrowIcon = ({ isFocused }: { isFocused: boolean }) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M1 8.5925H12.17L7.29 13.4725C6.9 13.8625 6.9 14.5025 7.29 14.8925C7.68 15.2825 8.31 15.2825 8.7 14.8925L15.29 8.3025C15.68 7.9125 15.68 7.2825 15.29 6.8925L8.71 0.2925C8.32 -0.0975 7.69 -0.0975 7.3 0.2925C6.91 0.6825 6.91 1.3125 7.3 1.7025L12.17 6.5925H1C0.45 6.5925 0 7.0425 0 7.5925C0 8.1425 0.45 8.5925 1 8.5925Z'
      fill={isFocused ? 'white' : 'black'}
    />
  </svg>
);

const CheckIcon = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M8.79508 15.875L4.62508 11.705L3.20508 13.115L8.79508 18.705L20.7951 6.70501L19.3851 5.29501L8.79508 15.875Z'
      fill='black'
    />
  </svg>
);

const LoaderIcon = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className='loader'
  >
    <circle
      cx='12'
      cy='12'
      r='10'
      stroke='black'
      strokeWidth='3'
      strokeLinecap='round'
      strokeDasharray='31.416'
      strokeDashoffset='23.562'
      opacity='0.3'
    />
    <circle
      cx='12'
      cy='12'
      r='10'
      stroke='black'
      strokeWidth='3'
      strokeLinecap='round'
      strokeDasharray='31.416'
      strokeDashoffset='31.416'
    >
      <animate
        attributeName='stroke-dashoffset'
        dur='1.5s'
        values='31.416;0;31.416'
        repeatCount='indefinite'
        calcMode='linear'
      />
      <animateTransform
        attributeName='transform'
        type='rotate'
        dur='1.5s'
        values='0 12 12;360 12 12'
        repeatCount='indefinite'
        calcMode='linear'
      />
    </circle>
  </svg>
);

export { ArrowIcon, ChatIcon, CheckIcon, LoaderIcon, MailIcon };
